import { clsx } from '../clsx';
import { Skeleton } from './Skeleton';
import styles from './TableSkeleton.module.css';

export interface TableSkeletonProps {
  /** Grid tracks, e.g. ['minmax(0,1.4fr)', '140px', 'minmax(0,1fr)']; a number gives that many equal columns. */
  columns: ReadonlyArray<string> | number;
  rows?: number | undefined;
  headerTone?: 'sunken' | 'plain' | undefined;
  /** Renders the first cell with an avatar circle (contact lists). */
  avatar?: boolean | undefined;
  className?: string | undefined;
}

const WIDTHS = ['72%', '48%', '60%', '40%', '55%', '65%'];

/** Loading state of a table: header eyebrow lines and pulsing text lines in the same grid. */
export function TableSkeleton({
  columns,
  rows = 6,
  headerTone = 'sunken',
  avatar = false,
  className,
}: TableSkeletonProps) {
  const tracks =
    typeof columns === 'number' ? Array.from({ length: columns }, () => 'minmax(0,1fr)') : columns;
  const template = tracks.join(' ');
  return (
    <div
      aria-busy="true"
      aria-label="Wird geladen"
      className={clsx(styles.table, headerTone === 'plain' ? styles.plain : styles.sunken, className)}
    >
      <div className={styles.header} style={{ gridTemplateColumns: template }}>
        {tracks.map((_, index) => (
          <Skeleton key={index} width={WIDTHS[index % WIDTHS.length]} height={8} />
        ))}
      </div>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div key={rowIndex} className={styles.row} style={{ gridTemplateColumns: template }}>
          {tracks.map((_, columnIndex) => (
            <span key={columnIndex} className={styles.cell}>
              {avatar && columnIndex === 0 ? <Skeleton variant="circle" width={28} /> : null}
              <Skeleton width={WIDTHS[(rowIndex + columnIndex) % WIDTHS.length]} />
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}
